export const PROJECTS = [
  {
    id: "shogun",
    index: "01",
    title: "Shogun",
    category: "Cinematic",
    year: "2026",
    runtime: "3:17",
    description:
      "A moody feudal-Japan cinematic staged and rendered in real time with Unreal Engine.",
    embed: "https://www.youtube.com/embed/_LclQzjWCwk?rel=0&modestbranding=1",
    poster: "https://images.unsplash.com/photo-1754474479806-5e07e3a9d8c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    span: "lg:col-span-8",
  },
  {
    id: "starwars-hangar",
    index: "02",
    title: "Star Wars Hangar",
    category: "Environment",
    year: "2026",
    runtime: "0:21",
    description: "A sci-fi hangar environment flythrough — set dressing, mood and lighting study.",
    embed: "https://www.youtube.com/embed/8JLPnq-FlhM?rel=0&modestbranding=1",
    poster: "https://i.ytimg.com/vi/8JLPnq-FlhM/maxresdefault.jpg",
    span: "lg:col-span-4",
  },
  {
    id: "sci-fi-lab",
    index: "03",
    title: "Sci-Fi Lab",
    category: "Level Design & Lighting",
    year: "2021",
    runtime: "1:08",
    description: "A sci-fi laboratory level built and lit in Unreal Engine, featuring a time-machine centerpiece.",
    embed: "https://www.youtube.com/embed/TixHCO2xJPI?rel=0&modestbranding=1",
    poster: "https://i.ytimg.com/vi/TixHCO2xJPI/maxresdefault.jpg",
    span: "lg:col-span-4",
  },
  {
    id: "simple-shooter",
    index: "04",
    title: "Simple Shooter",
    category: "Game Demo",
    year: "2022",
    runtime: "1:04",
    description:
      "A third-person shooter demo with AI-driven NPCs and a shooting architecture built in Unreal Engine and C++.",
    embed: "https://www.youtube.com/embed/dFSa22Rnazg?rel=0&modestbranding=1",
    poster: "https://i.ytimg.com/vi/dFSa22Rnazg/maxresdefault.jpg",
    span: "lg:col-span-8",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "The Void",
    body: "Every frame starts as absolute darkness. I treat the empty viewport like a blank strip of film, waiting for the first photon. That reverence for nothing is where the mood is born.",
  },
  {
    num: "02",
    title: "The Engine",
    body: "Unreal Engine is my camera, my gaffer, and my location scout. Real-time rendering lets me chase a feeling instead of a render queue, tweaking a sunset until it aches, then doing it again.",
  },
  {
    num: "03",
    title: "The Quirk",
    body: "Polished is boring. I hide a wink in every piece, a floating rubber duck, a suspiciously happy robot, a color that has no business being there. Professional craft, unserious soul.",
  },
];
